import React, { useState, useEffect, useCallback } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import parse from 'html-react-parser'
import { useSelector } from 'react-redux';
import Link from 'next/link'
import Header from '../../components/header'
import Breadcrumb from '../../components/breadcrumb'
import Productimage from '../../components/product/productimage'
import Variations from '../../components/product/variations'
import MetaTags from '../../components/MetaTags'

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const Footer = dynamic(() => import('../../components/footer'))
const MiniCart = dynamic(() => import('../../components/cart/minicart'))
const Noresults = dynamic(() => import('../../components/noresults'))
const Reviews = dynamic(() => import('../../components/reviews/reviews'))
const Related = dynamic(() => import('../../components/related/related'))
const VariationsTable = dynamic(() => import('../../components/product/variationsTable'))

import store from '../../redux/store'
import { removeUser } from '../../redux/user.slice';
import { clearShipping } from '../../redux/shipping.slice';
import { clearAddresses } from '../../redux/address.slice';

import * as ga from '../../lib/ga'
import Scripts from "../../components/scripts";

function Product({ item, menu, config, all_attributes }) {
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const router = useRouter();
  const [loading, set_loading] = useState(false);
  const [error, set_error] = useState(false);

  const [stored_product, set_stored_product] = useState(item);

  ga.view_item(stored_product)

  const useMediaQuery = (width) => {
    const [targetReached, setTargetReached] = useState(false);

    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`)
      media.addEventListener('change', e => updateTarget(e))

      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true)
      }

      return () => media.removeEventListener('change', e => updateTarget(e))
    }, [updateTarget, width])

    return targetReached;
  };

  const is_mobile = useMediaQuery(1023)

  useEffect(() => {

    const merchant_api_call = async (url) => {
      set_loading(true)
      const res = fetch(
        process.env.NEXT_PUBLIC_API_URL + '/product_pricing/' + url,
        {
          body: JSON.stringify({
            device_name: 'browser'
          }),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + token
          },
          method: 'POST'
        }
      )

        .then(response => {
          // reject not ok response
          if (!response.ok) {
            return Promise.reject(response)
          }
          return response.json() // or return response.text()
        })
        .catch(async response => {
          if (!response.ok && response.redirected) {
            set_error('You have logged in on another device, please login again to see pricing')
          }
          const error = await response.json().then(text => text)
          return Promise.reject(error)
        })
        .then(data => {
          // herre I need to overwrite the product that we are using with the new data
          set_stored_product(data.data)
          set_loading(false)
        })
        .catch((error) => {
          console.warn(error);
        });

    }

    const api_call_basket_validate = async () => {
      if (token) {
          var endpoint = '/validate_cart'
          var headers = {
              'Content-Type': 'application/json',
              'Authorization': "Bearer " + token
          }
          
        fetch(
          process.env.NEXT_PUBLIC_API_URL + endpoint,
          {
              body: JSON.stringify({
                  cart: cart
              }),
              headers: headers,
              method: 'POST'
          }
          ) .then(response => {
            // reject not ok response
            if (!response.ok) {
              return Promise.reject(response)
            }
            return response.json() // or return response.text()
          })
          .catch(async response => {
            if (!response.ok && response.redirected) {
              set_error('You have logged in on another device, please login again to continue!')
            }
            const error = await response.json().then(text => text)
            return Promise.reject(error)
          })
          .then(data => {
            set_error(false)
            // herre I need to overwrite the product that we are using with the new data
          })
          .catch((error) => {
            console.warn(error);
          });
      } 
    }

    var token = false
    var merchant = false
    if (user[0] != undefined) {
      token = user[0].token
      if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
        merchant = true
      }
    }

    if (merchant) {
      // re fetch data for their specific needs
      merchant_api_call(item.url)
    }else{
      api_call_basket_validate()
    }

  }, [item, user]);

  // if (!stored_product) {
  //   router.push('/404', undefined, { shallow: false })
  // }

  // router.events.on("routeChangeComplete", () => {
  //   set_stored_product(item)
  // })

  // if item changes, reload it into the store
  useEffect(() => {
    set_stored_product(item)
  }, [item])



  const logout_and_redirect_to_login = () => {
    store.dispatch(clearShipping())
    store.dispatch(clearAddresses())
    store.dispatch(removeUser())
    router.push('/login', undefined, { shallow: true })
  }

  return (
    <>
    
      <MetaTags item={item} config={config}></MetaTags>

      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        {(stored_product) ? (
          <section className="content flex flex-grow flex-col">
            <Breadcrumb item={stored_product}></Breadcrumb>
            {(error) ? (
              <Popup open={true} closeOnDocumentClick={false} closeOnEscape={false} position="right center">
                <div className="bg-white border border-2 p-10 flex flex-col items-center">
                  {error}
                  <span onClick={() => logout_and_redirect_to_login()} className="mt-5 btn btn-primary p-3 w-40">Login</span>
                  </div>
              </Popup>
            ) : ('')}
            <div className="py-8 lg:py-16">
              <div className="container mx-auto">
                <div className="block lg:flex items-stretch mx-auto w-full lg:w-4/5 px-5 lg:px-0 flex-row flex-grow">
                  {(is_mobile) ? (
                    <h1 className="text-gray-900 mt-4 lg:mt-0 mb-4">{stored_product.name}</h1>
                  ) : ('')}
                  <Productimage item={stored_product}></Productimage>
                  <div className="w-full lg:w-1/2 self-start">
                    {(!is_mobile) ? (
                      <h1 className="text-gray-900 mt-4 lg:mt-0 mb-4">{stored_product.name}</h1>
                    ) : ('')}
                    <Variations item={stored_product} all_attributes={all_attributes} loading={loading} config={config}></Variations>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white py-10 px-5 lg:px-0">
              <div className="container mx-auto">
                <div className="items-center mx-auto w-full lg:w-4/5">
                  <h2 className="text-gray-900 mb-4 pb-4 border-b border-gray-300">Product Details</h2>
                </div>
                <div className="block lg:flex items-center mx-auto w-full lg:w-4/5 redback1-override lg:mb-0 mb-4">
                  {(stored_product.description) ? (parse(stored_product.description)) : ('')}
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mx-auto w-full lg:w-4/5 mt-8">
                  <VariationsTable item={stored_product}></VariationsTable>
                  <div className="documents">
                    <h4 className="h4 mb-4">Documents</h4>
                    {item && item.media && item.media.map((image) => (
                      image.collection_name == 'pdfs') ? (
                      <div className="mb-1">
                        <i className="fas fa-file-pdf text-brand-tertiary mr-2"></i>
                        <Link href={image.original_url} passHref>
                          <a target="_blank" rel="noopener noreferrer" className="text-link">
                            {image.name}
                          </a>
                        </Link>
                      </div>
                    ) : ('')
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Reviews item={stored_product}></Reviews>
            <Related list={stored_product.relatedproducts} loading={loading}></Related>
          </section>
        ) : (
          <Noresults></Noresults>
        )}
        <Footer menu={menu} config={config}></Footer>
      </div >
      <MiniCart></MiniCart>
      <Scripts javascripts={item.javascripts}></Scripts>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/products/' + context.params.url)
  const response = await res.json()
  const product = (response.status) ? (response.data) : (false)

  const attr = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/attribute/')
  const attrresponse = await attr.json()
  const all_attributes = attrresponse.data

  if (!product) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      config: config,
      menu: menu,
      item: product,
      all_attributes: all_attributes
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths() {
  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/products')
  const response = await res.json()
  const products = response.data.data

  // Get the paths we want to pre-render based on products
  const paths = products.map((product) => ({
    params: {
      url: product.url.toString(),
    },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: 'blocking' }
}


export default Product